<template>
  <div class="dimed wrap">
    <div class="layer layer--pdnew">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Sco.Basket.msg1') }}</div>
        <div class="ft-point">
          {{ $t('Modal.Sco.Basket.msg2') }}
        </div>
      </div>

      <div id="list" v-show="!detailYn">
        <div class="menu__body--box03" id="menuBody">
          <div
            class="w-box btn-anim btn--shadow"
            v-for="(item, i) in kioskItem"
            :key="item"
            @mouseup="
              itemNum = i;
              detailYn = true;
            "
          >
            <div class="img-area">
              <img :src="item.SUB_ITEM_IMG_FILE_URL == null ? replaceToDefaultImg : item.SUB_ITEM_IMG_FILE_URL" @error="replaceToDefaultImg" alt="" />
            </div>
            <div class="txt-area">{{ item.DIS_ITEM_NM }}</div>
          </div>
        </div>
        <div class="table-btn">
          <button v-if="kioskItem.length > 4" class="btn-tb-btm up" @mouseup="moveheader(-50)"><i class="ico-arr-u">위</i></button>
          <button v-if="kioskItem.length > 4" class="btn-tb-btm down" @mouseup="moveheader(50)"><i class="ico-arr-d">아래</i></button>
        </div>

        <div class="layer__button">
          <button class="btn btn--line btn--xlg btn-anim" @mouseup="$emit('closeBasket')">{{ $t('Modal.Sco.Basket.msg3') }}</button>
        </div>
      </div>
      <!-- detail -->
      <div id="detail" v-show="detailYn">
        <div class="layer__body">
          <div class="flex-row">
            <div class="input-area">
              <label for="">{{ $t('Modal.Sco.Basket.msg10') }}</label>
              <input type="text" :value="number" :placeholder="$t('Modal.Sco.Basket.msg4')" />
            </div>
            <div class="lyr-left img-info-bdr">
              <div class="ico-area">
                <img
                  :src="kioskItem[itemNum].SUB_ITEM_IMG_FILE_URL == null ? replaceToDefaultImg : kioskItem[itemNum].SUB_ITEM_IMG_FILE_URL"
                  @error="replaceToDefaultImg"
                  alt=""
                />
              </div>
              <div class="txt-area">{{ kioskItem[itemNum].DIS_ITEM_NM }}</div>
            </div>
            <div class="lyr-right">
              <div class="keypad keypad--lg">
                <button class="btn-anim" @mouseup="setNumber(1)">1</button>
                <button class="btn-anim" @mouseup="setNumber(2)">2</button>
                <button class="btn-anim" @mouseup="setNumber(3)">3</button>
                <button class="btn-anim" @mouseup="setNumber(4)">4</button>
                <button class="btn-anim" @mouseup="setNumber(5)">5</button>
                <button class="btn-anim" @mouseup="setNumber(6)">6</button>
                <button class="btn-anim" @mouseup="setNumber(7)">7</button>
                <button class="btn-anim" @mouseup="setNumber(8)">8</button>
                <button class="btn-anim" @mouseup="setNumber(9)">9</button>
                <button @mouseup="setNumber(10)" class="delete btn-anim">{{ $t('Modal.Sco.Basket.msg5') }}</button>
                <button class="btn-anim" @mouseup="setNumber(0)">0</button>
                <button @mouseup="setNumber(-1)" class="btn-back btn-anim">{{ $t('Modal.Sco.Basket.msg6') }}</button>
              </div>
            </div>
          </div>
        </div>

        <div class="menu__footer">
          <dl class="basic-price">
            <dt>{{ $t('Modal.Sco.Basket.msg7') }}</dt>
            <dd class="ft--point">{{ $displayUprc(number * $detailUprc(kioskItem[itemNum])) }}</dd>
          </dl>
        </div>

        <div class="layer__button">
          <button class="btn btn--cancel" @mouseup="detailYn = false">{{ $t('Modal.Sco.Basket.msg8') }}</button>
          <button class="btn btn--submit" :disabled="number < 1" @mouseup="setInputBaskets">{{ $t('Modal.Sco.Basket.msg9') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import audioHelper from '@/js/common/audioHelper.js';
import _ from 'lodash';

export default {
  name: 'basket',
  data() {
    return {
      locales: 'jp',
      darkModeYn: this.$store.getters.getDarkModeYn,
      kioskItem: this.$store.getters.getKioskItem.filter((item) => item.KOS_CLASS_CD == this.kosClassCd),
      detailYn: false,
      itemNum: 0,
      number: '',
    };
  },
  props: {
    currUnitText: String,
    kosClassCd: String,
  },
  mounted() {
    this.$changeDarkMode(this.darkModeYn);

    //언어 변경
    if (this.$i18n.locale == 'jp') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_JP;
      });
    } else if (this.$i18n.locale == 'ko') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_KO;
      });
    } else if (this.$i18n.locale == 'en') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_EN;
      });
    } else if (this.$i18n.locale == 'cn') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_CN;
      });
    } else if (this.$i18n.locale == 'tw') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_TW;
      });
    }
  },
  methods: {
    replaceToDefaultImg(e) {
      // 상품 이미지 로딩 실패 시 기본 이미지 표시
      e.target.src = require('@/assets/images/common/no-image.png');
    },
    moveheader(movenum) {
      var menuBody = document.getElementById('menuBody');
      menuBody.scrollTop += movenum;
    },
    setNumber(num) {
      if (num == 10) {
        this.number = '';
      } else if (num < 0) {
        this.number = this.number.slice(0, -1);
      } else if (this.number == '0') {
        this.number = num + '';
      } else if (this.number.length < 2) {
        this.number += num + '';
      }
    },
    setInputBaskets() {
      let itemObj = _.cloneDeep(this.kioskItem[this.itemNum]);
      itemObj.SALES_QTY = Number(this.number);
      this.$logInfo(`No Barcode Item Add Item : ${JSON.stringify(itemObj)}`);

      this.$emit('setInputBaskets', itemObj);
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    helperYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00054', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/pages/sco.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/menu-dark.css" scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style scoped>
.img-info-bdr .ico-area{
  height : 6.8em;
}

.menu__body--box03 .w-box .txt-area{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 3;
}

</style>
